import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedPatient: null,
    healthMapItems: [],
    searchResults: [],
    loading: false,
    searchLoading: false,
    error: null,
    theme: localStorage.getItem("healthmap-theme") || "light",
    activeOverlay: null, // null | 'prescription' | 'receipt' | 'note'
    pdfOverlay: null, // { url, type, id } or null
};

const healthMapSlice = createSlice({
    name: "healthMap",
    initialState,
    reducers: {
        setSelectedPatient: (state, action) => {
            state.selectedPatient = action.payload;
        },
        clearSelectedPatient: (state) => {
            state.selectedPatient = null;
            state.healthMapItems = [];
        },
        setHealthMapItems: (state, action) => {
            state.healthMapItems = action.payload;
        },
        addHealthMapItem: (state, action) => {
            state.healthMapItems = [action.payload, ...state.healthMapItems];
        },
        updateHealthMapItem: (state, action) => {
            const { id, type, data } = action.payload;
            const idx = state.healthMapItems.findIndex(
                (item) => item.id === id && item.type === type
            );
            if (idx !== -1) {
                state.healthMapItems[idx] = {
                    ...state.healthMapItems[idx],
                    ...data,
                };
            }
        },
        removeHealthMapItem: (state, action) => {
            const { id, type } = action.payload;
            state.healthMapItems = state.healthMapItems.filter(
                (item) => !(item.id === id && item.type === type)
            );
        },
        setSearchResults: (state, action) => {
            state.searchResults = action.payload;
        },
        clearSearchResults: (state) => {
            state.searchResults = [];
        },
        setHealthMapLoading: (state, action) => {
            state.loading = action.payload;
        },
        setSearchLoading: (state, action) => {
            state.searchLoading = action.payload;
        },
        setHealthMapError: (state, action) => {
            state.error = action.payload;
        },
        setTheme: (state, action) => {
            state.theme = action.payload;
            localStorage.setItem("healthmap-theme", action.payload);
        },
        setActiveOverlay: (state, action) => {
            state.activeOverlay = action.payload;
        },
        setPdfOverlay: (state, action) => {
            state.pdfOverlay = action.payload;
        },
    },
});

export const {
    setSelectedPatient,
    clearSelectedPatient,
    setHealthMapItems,
    addHealthMapItem,
    updateHealthMapItem,
    removeHealthMapItem,
    setSearchResults,
    clearSearchResults,
    setHealthMapLoading,
    setSearchLoading,
    setHealthMapError,
    setTheme,
    setActiveOverlay,
    setPdfOverlay,
} = healthMapSlice.actions;

export default healthMapSlice.reducer;
